import * as React from 'react';
import { IReturnButtonProps } from '@cian/frontend-request-form-widget';
import { ArticleHeading4, Body1 } from '@cian/ui-kit';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import { useDeviceType } from '@cian/ui-kit/responsive';

import * as styles from './styles.css';

export const PrevQuestionButton: React.FC<IReturnButtonProps> = props => {
  const { onPrevStep, isFirstStep } = props;
  const isDesktop = useDeviceType() === 'desktop';

  if (isFirstStep) {
    return null;
  }

  return (
    <button type="button" onClick={onPrevStep} className={styles['button']} data-testid="return-to-current-stage">
      <span className={styles['icon']}>
        <IconActionChevronLeft16 color={'current_color'} display={'block'} />
      </span>
      {isDesktop ? (
        <ArticleHeading4 color={'current_color'}>Предыдущий вопрос</ArticleHeading4>
      ) : (
        <Body1 display="inline" color={'current_color'}>
          Назад
        </Body1>
      )}
    </button>
  );
};

PrevQuestionButton.displayName = 'PrevQuestionButton';
